import { ForgotPassword } from './ForgotPassword';
import { GuestForms } from './GuestForms';
import { Login } from './Login';
import { Register } from './Register';
import { ResetPassword } from './ResetPassword';

export {
  ForgotPassword,
  GuestForms,
  Login,
  Register,
  ResetPassword
}